"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactCollapse = require("react-collapse");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _minusThin = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/minus-thin"));

var _plusThin = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/plus-thin"));

var _uiKit = require("@dbi-tools/ui-kit");

var _expander = require("./expander.styled");

var _headerTitles = require("../header-titles");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _const = require("./const");

var _themeOptions = require("../../helpers/theme-options");

var _helpers = require("../../helpers");

var _useMedia = require("../../hooks/use-media");

var _const2 = require("../../const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ExpanderUi = function ExpanderUi(props) {
  var storyItems = props.storyItems,
      _props$isStorybook = props.isStorybook,
      isStorybook = _props$isStorybook === void 0 ? false : _props$isStorybook,
      id = props.id,
      _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _const.ExpanderTheme.WHITE : _props$theme,
      headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      removeBottomPadding = props.removeBottomPadding,
      removeTopPadding = props.removeTopPadding,
      children = props.children,
      _props$items = props.items,
      items = _props$items === void 0 ? {} : _props$items,
      expandedItemsInit = props.expandedItems,
      singleExpansion = props.singleExpansion,
      _props$buttons = props.buttons,
      buttons = _props$buttons === void 0 ? [] : _props$buttons;

  if (!headline1 && !headline2 && !description && (0, _isEmpty.default)(buttons) && (0, _isEmpty.default)(children)) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure EXPANDER component");
  }

  var _useState = (0, _react.useState)(expandedItemsInit),
      _useState2 = _slicedToArray(_useState, 2),
      expandedItems = _useState2[0],
      setExpandedItems = _useState2[1];

  var isMobile = (0, _useMedia.useMedia)(_const2.Breakpoints.MOBILE);
  var isDesktop = (0, _useMedia.useMedia)(_const2.Breakpoints.DESKTOP);
  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color,
      type = _themeStrategy$curren.type,
      size = _themeStrategy$curren.size;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isAltTheme = size === _themeOptions.ThemeSize.HALF;
  var btnColor = isAltTheme ? 'gray800' : (0, _helpers.getButtonColorByTheme)(isDarkTheme);
  var textColor = isAltTheme ? 'gray800' : headline2Color;
  var linkColor = isDarkTheme && !isAltTheme ? 'white' : 'wine';
  var defaultPadding = isMobile ? 30 : 60;
  var bottomIndent = removeBottomPadding ? 0 : defaultPadding;
  var topIndent = removeTopPadding ? 0 : defaultPadding;
  var containerIndent = [topIndent, 0, bottomIndent];
  var containerIndentDefault = [defaultPadding, 0, defaultPadding];
  var theme = {
    $theme: currentTheme,
    $descriptionLinkColor: linkColor // TODO update styles from master list, when design team added it.
    // $styles: basicStyles,

  };

  var handleCollapse = function handleCollapse(itemKey) {
    var isActive = expandedItems.indexOf(itemKey) > -1;

    var expandedItemsTemp = _toConsumableArray(expandedItems);

    if (singleExpansion) {
      expandedItemsTemp = isActive ? [] : [itemKey];
    } else {
      if (isActive) {
        var index = expandedItems.indexOf(itemKey);
        expandedItemsTemp.splice(index, 1);
      } else {
        expandedItemsTemp.push(itemKey);
      }
    }

    setExpandedItems(expandedItemsTemp);
  };

  var iconSize = isDesktop ? 18 : 14;

  var header = function header(title, isExpanded, key) {
    return /*#__PURE__*/_react.default.createElement(_expander.ExpanderItemHeaderStyled, {
      onClick: function onClick() {
        return handleCollapse(key);
      }
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      as: "h5",
      fontWeight: "bold",
      fontSize: {
        xs: 14,
        lg: 18
      },
      color: textColor,
      lineHeight: {
        xs: 21,
        lg: 27
      },
      m: [0]
    }, title ? title : _const.TITLE_PLACEHOLDER), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      variant: "link",
      color: btnColor,
      pl: 30
    }, isExpanded ? /*#__PURE__*/_react.default.createElement(_minusThin.default, {
      measure: iconSize
    }) : /*#__PURE__*/_react.default.createElement(_plusThin.default, {
      measure: iconSize
    })));
  };

  var body = function body(item, isExpanded) {
    return /*#__PURE__*/_react.default.createElement(_reactCollapse.Collapse, {
      isOpened: isExpanded
    }, item);
  };

  var expanderContent = (0, _react.useMemo)(function () {
    return !(0, _isEmpty.default)(children) && _react.default.Children.map(children, function (item, index) {
      var _item$props = item.props,
          title = _item$props['cq:panelTitle'],
          id = _item$props.id;
      var key = Object.keys(items).find(function (key) {
        return items[key] === id;
      });
      var isExpanded = expandedItems.indexOf(key) > -1;
      return /*#__PURE__*/_react.default.createElement(_expander.ExpanderItemStyled, {
        key: index,
        isDarkTheme: isDarkTheme && !isAltTheme
      }, header(title, isExpanded, key), body(item, isExpanded));
    });
  }, [_toConsumableArray(expandedItems)]);
  var expanderContentStory = (0, _react.useMemo)(function () {
    return !(0, _isEmpty.default)(storyItems) && storyItems.map(function (_ref, index) {
      var title = _ref.title,
          id = _ref.id,
          content = _ref.content;
      var key = Object.keys(items).find(function (key) {
        return items[key] === id;
      });
      var isExpanded = expandedItems.indexOf(key) > -1;
      return /*#__PURE__*/_react.default.createElement(_expander.ExpanderItemStyled, {
        key: index,
        isDarkTheme: isDarkTheme && !isAltTheme
      }, header(title, isExpanded, key), body(content, isExpanded));
    });
  }, [_toConsumableArray(expandedItems)]);
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_expander.StyledBox, {
    id: id,
    p: isAltTheme ? containerIndentDefault : containerIndent
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Container, null, /*#__PURE__*/_react.default.createElement(_expander.AltContainerStyled, {
    pt: !isAltTheme ? 0 : topIndent,
    pb: !isAltTheme ? 0 : bottomIndent,
    isAltTheme: isAltTheme
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Row, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    lg: 10
  }, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: isAltTheme ? 'primaryDark' : headline1Color,
    headline2Color: textColor,
    noGutters: true,
    mb: 25
  }), /*#__PURE__*/_react.default.createElement(_expander.ExpanderUiStyled, null, isStorybook ? expanderContentStory : expanderContent), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    mt: 45,
    buttons: buttons,
    color: btnColor
  })))))));
};

var _default = ExpanderUi;
exports.default = _default;